import _ from 'lodash';
import ah from '../utils/ajax-helper'; // get Terminal Rfid Visit Log for seven

export var getTerminalRfidVisitLog = function getTerminalRfidVisitLog(contextRoot, noProgress, dateRange) {
  var queryTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  var sort = arguments.length > 4 ? arguments[4] : undefined;
  var offset = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
  var limit = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 20;
  return new Promise(function (resolve, reject) {
    var sortField = sort ? sort.field : 'exitTime';
    var sortOrder = sort ? sort.desc ? 'desc' : 'asc' : 'desc';
    var requestParameters = {
      'log-type': 'all',
      'terminal-id': 'TWKHH_TS03',
      'query-time': queryTime,
      sort: sortField + ':' + sortOrder,
      start: dateRange.from,
      end: dateRange.to,
      offset: offset,
      limit: limit
    };
    ah.get("".concat(contextRoot, "/terminal/rfid/logs"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得七櫃RFID進出資訊的統計結果 TerminalRfidVisitLog

export var getTerminalRfidLogsStats = function getTerminalRfidLogsStats(contextRoot, noProgress, dateRange) {
  var queryTime = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      'log-type': 'all',
      'terminal-id': 'TWKHH_TS03',
      start: dateRange.from,
      end: dateRange.to,
      'query-time': queryTime
    };
    ah.get("".concat(contextRoot, "/terminal/rfid/logs/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
}; // 取得七櫃過去24小時平均進出時間統計資料

export var getTerminalRfidHistStats = function getTerminalRfidHistStats(contextRoot, noProgress, dateRange) {
  return new Promise(function (resolve, reject) {
    var requestParameters = {
      start: dateRange.from,
      end: dateRange.to
    };
    ah.get("".concat(contextRoot, "/terminal/rfid/hist/stats"), requestParameters, null, noProgress).then(function (result) {
      if (result.code < 0) throw new Error(result.error);
      resolve(result.data);
    }).catch(function (error) {
      reject(error);
    });
  });
};